import React, { useState } from "react";
import PopOver from "../../../components/View/PopOver";
import {
  ActionIcon,
  Button,
  ColorInput,
  ColorSwatch,
  Group,
  Stack,
} from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { useLanguage } from "../../../stores/LanguageStore";
import BackButton from "../../../components/View/BackButton";
import { editTag, getTags } from "../../../api/TagsAPI";
import {
  getTagBackgroundColor,
  getTagsSwatches,
} from "../../../functions/utilFunctions";

const TagsColorEditor = ({ tag, isSwatch, onFinished }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(tag?.color);

  const handleEdit = (handleClose) => {
    const newTag = { ...tag, color: value ? value.substring(1) : undefined };

    setLoading(true);
    editTag(newTag)
      .then((r) => {
        if (onFinished) {
          handleClose();
          setLoading(false);
          return onFinished();
        }
        getTags()
          .then(() => handleClose())
          .finally(() => setLoading(false));
      })
      .catch(() => setLoading(false));
  };

  const onOpen = (handleOpen) => {
    handleOpen();
    setValue(tag.color);
  };

  return (
    <PopOver
      opener={(handleOpen, ref) =>
        isSwatch ? (
          <ColorSwatch
            ref={ref}
            onClick={(e) => onOpen(() => handleOpen(e))}
            color={
              tag.color ? `#${tag.color}` : getTagBackgroundColor(tag.name)
            }
          />
        ) : (
          <ActionIcon
            ref={ref}
            onClick={(e) => onOpen(() => handleOpen(e))}
            className="deleter"
            size={"xs"}
            pos={"absolute"}
            top={3}
            right={24}
            radius={"sm"}
          >
            <IconEdit size={12} />
          </ActionIcon>
        )
      }
      popoverChildren={(handleClose) => (
        <Stack gap={"sm"}>
          <ColorInput
            label={lang.prm.status.color}
            placeholder={lang.prm.status.color}
            required
            value={value || ""}
            onChange={setValue}
            format="hex"
            w={"100%"}
            popoverProps={{
              zIndex: 1500,
              withinPortal: false,
              opened: true,
              keepMounted: true,
            }}
            closeOnColorSwatchClick={true}
            swatches={getTagsSwatches()}
            styles={{
              dropdown: {
                width: "100%",
                display: "flex",
                height: "auto",
                position: "static",
              },
              swatches: {
                position: "static",
              },
            }}
          />

          <Group mt={"auto"} justify="end">
            <BackButton onClick={handleClose} />

            <Button onClick={() => handleEdit(handleClose)} loading={loading}>
              {lang.global.save}
            </Button>
          </Group>
        </Stack>
      )}
    />
  );
};

export default TagsColorEditor;
